import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TagModel} from './tag.model';

@Component({
    selector: 'app-tag',
    template: `
    <span class="tag" [style.backgroundColor]="tag.color">
      {{tag.name}}
    </span>
  `,
    styles: [
        '.tag {display: inline-block; border-radius: 5px; padding: 2px 6px; color: white;}'
    ],
    standalone: true
})
export class TagComponent implements OnChanges, OnInit {

  @Input() tag: TagModel;

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit() {
    // console.log(this.optionsMap);
  }

}
